import { OrderDirection } from '@api/twin/AnomalyApi';
import { datadogRum } from '@datadog/browser-rum';
import { Box } from '@stereograph/teia-system-design/components/Box';
import { usePluginTranslation } from '@translation';
import { useState } from 'react';
import { SwitchOrderDirectionButton } from '../history/SwitchOrderDirectionButton';
import { AnomalySectionLayout } from '../tabs/AnomalySectionLayout';
import { AnomalyCommentList } from './AnomalyCommentList';
import { CreateAnomalyCommentForm } from './CreateAnomalyCommentForm';

export const AnomalyCommentSection = () => {
  const { t } = usePluginTranslation();
  const [orderDirection, setOrderDirection] = useState<OrderDirection>('desc');

  const onChange = (orderDirection: OrderDirection) => {
    setOrderDirection(orderDirection);
    datadogRum.addAction('tvp.anomaly.comment.sort', {
      orderDirection,
    });
  };

  return (
    <AnomalySectionLayout
      title={t('anomaly_plugin.widget.sections.comment_section.title')}
      headerRight={
        <SwitchOrderDirectionButton orderDirection={orderDirection} onChange={onChange} />
      }
    >
      <AnomalyCommentList orderDirection={orderDirection} />
      <Box sx={{
        py: 4,
      }}
      >
        <CreateAnomalyCommentForm />
      </Box>
    </AnomalySectionLayout>
  );
};
